export default __webpack_public_path__ + "resources/icons/n300-c921.png";